import React from 'react';

import {
  useLoadUser,
  useUpdateUser,
  useCreateUser,
} from 'scenes/Users/AdminUsers/data';
import {
  CATEGORY_ACTIONS,
  CATEGORY_AFFILIATES,
} from 'scenes/Users/components/UserPermissions/constants';
import { PERMISSION_ACTION_SEE_ALL_AFFILIATES } from 'scenes/Users/AdminUsers/constants';

import { IS_SYSTEM, PERMISSIONS } from './constants';
import UserForm from './UserForm';

export const normalizeSubmittedValues = ({
  [PERMISSIONS]: {
    [CATEGORY_ACTIONS]: actions,
    [CATEGORY_AFFILIATES]: affiliates,
    ...permissions
  },
  ...values
}) => {
  return {
    ...values,
    [PERMISSIONS]: {
      ...permissions,
      ...(actions
        ? {
            [CATEGORY_ACTIONS]: actions,
          }
        : null),
      ...(!actions?.includes(PERMISSION_ACTION_SEE_ALL_AFFILIATES) && affiliates
        ? {
            [CATEGORY_AFFILIATES]: affiliates,
          }
        : null),
    },
  };
};

export const UserFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
  ...props
}) => {
  const [createUser, { isLoading: isCreating }] = useCreateUser();

  const handleSubmit = async (values) => {
    await createUser(normalizeSubmittedValues(values));
    onClose();
  };

  return (
    <UserForm
      title={'Add User'}
      loading={isCreating}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={{ [IS_SYSTEM]: false }}
      {...props}
      onSubmit={handleSubmit}
    />
  );
};

export const UserFormDuplicate = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
  ...props
}) => {
  const [createUser, { isLoading: isCreating }] = useCreateUser();

  const { data, isLoading } = useLoadUser(id);
  const handleSubmit = async (values) => {
    await createUser(normalizeSubmittedValues(values));
    onSubmit();
  };

  return (
    <UserForm
      title={'Duplicate User'}
      subTitle={data?.name}
      initialValues={{
        department: data?.department,
        manager: data?.manager,
        permissions: data?.permissions,
      }}
      loading={isLoading || isCreating}
      onClose={onClose}
      enableReinitialize={true}
      onExited={onExited}
      open={open}
      {...props}
      onSubmit={handleSubmit}
      active={data}
    />
  );
};

export const UserFormEdit = ({ id, onClose, onExited, open, ...props }) => {
  const [updateUser, { isLoading: isUpdating }] = useUpdateUser();
  const { data, isLoading } = useLoadUser(id);

  const handleSubmit = async (values) => {
    await updateUser(normalizeSubmittedValues(values));
    onClose();
  };

  return (
    <UserForm
      title={'Edit User'}
      subTitle={data?.name}
      entityId={id}
      initialValues={data}
      loading={isLoading || isUpdating}
      onClose={onClose}
      enableReinitialize={true}
      editMode={true}
      onExited={onExited}
      open={open}
      {...props}
      onSubmit={handleSubmit}
      active={data}
    />
  );
};
